
<template>
        <v-card>
          
            <swatches 
				class="child"
				background-color="#eeeeee"
				colors="text-advanced" 
				inline
				true
				swatch-size="18"
				v-model="color"
				@click.stop=""
				@input="selectChangeHandler"/>
 
        </v-card>
	

</template>

<script>	
import Swatches from 'vue-swatches'
import "vue-swatches/dist/vue-swatches.min.css"

let ColorPicker = {
	name: ColorPicker,
	data() {
		return {
        	color: '#1CA085',
        	colors : ['#CC0001', '#E36101', '#FFCC00', '#009900', '#0066CB', '#000000', '#FFFFFF', ''],

      	}
	},
	props: {
            dialog: Boolean
        },

	components: { Swatches },

	methods: {

		selectChangeHandler: function (value) {
			this.$emit('change-color', this.color)
		},
	}
}
export default ColorPicker
</script>



<style>

	.child {	
	  	position : absolute;
	  	z-index: 1000000;   
	}

</style>





// WEBPACK FOOTER //
// src/components/buildingcard/ColorPicker.vue